﻿define([
	'jquery', 'pubsub', 'overLay', 'Handlebars', 'moduleUtilities', 'generalUtilities', 'locationConfirmCompiled',
	'mixpanelControl'],
	
	function ($, pubsub, overLay, Handlebars, moduleUtilities, generalUtilities, locationConfirmCompiled) {
		/**
		* re_locationconfirm_control
		* @exports locationConfirmControl
		* @author May Montazer
		* 
		*/

		//#region set up

		'use strict';

		var module, overLayModule;

		module = {};
		module.private = {};
		module.properties = {};

		// Initialize overlay.
		overLayModule = new overLay();
		overLayModule.init();

		/**
		* Determines whether the user have location info set or not.
		* @returns bool
		*/
		module.private.verifyUserWithoutLocation = function () {

			//no matter who you are if your city or country is false verify location
			if (!generalUtilities.prop(RESAAS, 'User2.City') ||
				!generalUtilities.prop(RESAAS, 'User2.CountryId')) {
				return true;
			}

			return false;
		};

		/**
		*Prevent to show the location update ovelay if it is shown before.
		* @returns bool
		*/
		module.private.showLocationUpdateOverlay = function () {
			var showOverlay;

			if (window.Modernizr && window.Modernizr.sessionstorage) {
				showOverlay = sessionStorage.getItem('LocationUpdateShown');
            }

            if (showOverlay === null) {
                return true;
            }

			return false;
		};

		/**
		* Initiates the module, creates a guid and binds dom events.
		* @param {object} [e] The pubsub event, optional depending module is self init or by pubsub event.
		* @param {object} [data] Data passed in by pubsub event, optional depending module is self init or by pubsub event.
		*/
		module.private.init = function (e, data) {
			var viewModel, locationTemplate, html;

			if (!generalUtilities.prop(window,'RESAAS.User2.IsProfessional')) {
				return false;
			}

			if ($('.js-paywall-container').length === 0) {
				if (module.private.verifyUserWithoutLocation() && module.private.showLocationUpdateOverlay()) {

					//module config
					module.properties.guid = (data && data.guid) ? data.guid : generalUtilities.uuid();

					html = locationConfirmCompiled();
					overLayModule.openOverlay(html);

					if (window.Modernizr && window.Modernizr.sessionstorage) {
						sessionStorage.setItem("LocationUpdateShown", "true");
					}
				}
			}
 
		};

		//#region external event bindings
		module.private.init();

		//#endregion
		//expose API
		return module;
	}
);
